import React from 'react';
import { Select, Tooltip } from 'antd';
import { Wrapper, Warning, StyledLabel } from './styled';
import { useSelector } from 'react-redux';
import { modeSelector } from '@store/trends/selectors';
import { WarningOutlined } from '@ant-design/icons';
import getGranularity from '@utils/granularity';
import { track } from '@utils';
import { CHANGED_TIME_GRANULARITY } from '@src/utils/sensor/track';
import { getAllowedGranularity, GranularityMap } from './utils';
import { MODE_AI_ALERT_DIAGNOSTICS, MODE_TRENDS } from '@store/trends/constants';
import { NOC_DRILLDOWN, isAppModule } from '@utils/constants';

function GranularitySelect({ updateGranularity, interval }) {
  const { mode } = useSelector(modeSelector);

  // this if condition should be removed along with appBackendScaled
  if (isAppModule) {
    if (mode === MODE_AI_ALERT_DIAGNOSTICS) {
      return null;
    }
  }

  if (!interval || ![MODE_TRENDS, NOC_DRILLDOWN].includes(mode)) {
    // compare dashboard page renders without interval while saving the dashboard
    return null;
  }

  const { from, to } = interval;
  const granularity = interval.granularity || getGranularity({ from, to, minuteGranularity: true });
  const allowedValues = getAllowedGranularity(interval);
  const options = allowedValues.map((o) => GranularityMap[o]);
  const invalidValue = !allowedValues.includes(granularity);
  const handleChange = (value: string) => {
    updateGranularity(value);
    track({
      event: CHANGED_TIME_GRANULARITY,
      data: { value },
    });
  };

  return (
    <Wrapper>
      <StyledLabel>Granularity</StyledLabel>
      <Select
        value={granularity}
        options={options}
        onChange={handleChange}
        variant="borderless"
        styles={{ popup: { root: { minWidth: 65 } } }}
      />
      {invalidValue && (
        <Warning>
          <Tooltip title="Selected granularity is invalid for the applied interval">
            <WarningOutlined />
          </Tooltip>
        </Warning>
      )}
    </Wrapper>
  );
}

export default GranularitySelect;
